/* eslint-disable react-hooks/exhaustive-deps */
import React, {useMemo, useEffect, useState} from 'react'
import DashboradLayout from '../../../../layouts/dashboard'
import Table from '../../../../components/common/Table'
import { getTeachers, deleteTeacher } from '../../../../http/teacher'
import ModalTeacher from '../Modal'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import css from './styles.module.scss'
import { FaTrash, FaPlus } from "react-icons/fa"
import { useParams, Link } from "react-router-dom"
import { getCourse } from '../../../../http/course'
import { NotificationManager } from 'react-notifications'

const TeacherList = () => {

  const size = 10
  const [currentTeacher, setCurrentTeacher] = useState({})
  const [modalOpen, setModalOpen] = useState(false)
  const [data, setData] = useState({rows: [], count: 0})
  const [course, setCourse] = useState({})
  const [searchable, setSearchable] = useState('')
  const [page, setPage] = useState(0)
  const params = useParams()
	const [loading, setLoading] = useState(true)
  const courseId = params.courseId

  const fetchTeachers = async () => {
    try{
      const teachers = await getTeachers({
        ...( searchable ? { name: searchable } : {}),
        ...(courseId ? { courseId } : {}),
        size,
        start: ( page || 0 ) * size
      })
      setData(teachers)
      setLoading(false)
    }catch(e){
      NotificationManager.error('Erro no servidor', 'Ocorreu um erro')
    }
  }

  const fetchCourse = async () => {
    try{
      const course = await getCourse(courseId)
      setCourse(course)
    }catch(e){
      NotificationManager.error('Erro no servidor', 'Ocorreu um erro')
    }
  }

  useEffect(() => {
    fetchCourse()
    document.title = "Professores - Alissem"
    document.getElementsByTagName("META")[1].content=document.title
  }, [])

  useEffect(() => {
    fetchTeachers()
  }, [searchable, page])

  const disassociate = async (data) => {
    if (window.confirm("Tem certeza que deseja desassociar esse professor? Essa operação não pode ser desfeita!")){
      try{
        await deleteTeacher(data.id)
        setSearchable('')
        fetchTeachers()
        setLoading(false)
        NotificationManager.success('Professor excluído com sucesso', 'Deletado com sucesso')
      }catch(e){
        setLoading(false)
        NotificationManager.error('Erro no servidor', 'Ocorreu um erro')
      }
    }
  }

  const closeModal = () => {
    setSearchable('')
    fetchTeachers()
    setCurrentTeacher({})
    setModalOpen(false)
  }

  const addTeacher = () => {
    setSearchable('')
    setCurrentTeacher({})
    setModalOpen(true)
  }

  const columns = useMemo(
    () => [
      {
        Header: "Aulas",
        columns: [
          { Header: 'Id', accessor: 'id', sortType: 'basic' }, 
          { Header: 'Nome', accessor: 'user.name', sortType: 'basic' }, 
          { Header: 'Ações', 
            Cell: ({row}) => (
              <div>
                <Button variant="link" onClick={() => disassociate(row.original)}>
                  <FaTrash />
                </Button>
              </div>
            )
          }
        ]
      }
    ], []
  );
  
  const breadcrumbs = course ? [
    {name: 'Início', url: '/dashboard'},
    {name: course.name, url: `/dashboard/empresa/${course.companyId}/curso/${course.id}/aulas`},
    {name: "Professores", url: `/dashboard/curso/${course.id}/professores`}
  ] : []

  return (
    <DashboradLayout loading={loading} breadcrumbs={breadcrumbs}>
      <div className="pg-teacher">
        <Row className={css['pg-teacher__filter']}>
          <Col className={css['pg-teacher__filter__searchable']}>
            <Form.Control 
              type="text" 
              placeholder='Busque por nome' 
              value={searchable} 
              onChange={e => setSearchable(e.target.value)}
            />
          </Col>
          {courseId && 
            <Col xs={3} className={css['pg-teacher__filter__actions']}>
              <Button onClick={ addTeacher }><FaPlus /> Nova</Button>
            </Col>
          }
        </Row>
        <Table 
          columns={columns} 
          data={data} 
          fetch={fetchTeachers} 
          size={size}
          className={css["pg-teacher__table"]}
          setPage={setPage}
        />
      </div>
      <ModalTeacher 
        show={modalOpen}
        handleClose={closeModal}
        teacher={currentTeacher}
        courseId={courseId} 
        setLoading={setLoading}
      />
    </DashboradLayout>
  )
}

export default TeacherList